import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import useAuth from "./hooks/useAuth";
import { ProtectedRoute } from "./pages/ProtectedRoute/ProtectedRoutePage";
import { StatusBar, Style } from "@capacitor/status-bar";
import { useEffect } from "react";
import ExplorePagesRoute from "./pages/explorePages/explorePagesRoute";
import UserAuthRoutes from "./pages/userAuthenticationpages/userAuthRoute";
import UserDashboardPagesRoute from "./pages/userDashboard/userDashboardPagesRoute";
import { useAppDispatch } from "./Redux/reduxCustomHook";

const App = () => {
  const authState = useAuth();
  const dispatch = useAppDispatch();

  const setStatusBarStyleLight = async () => {
    try {
      // await StatusBar.setStyle({ style: Style.Dark });
      // await StatusBar.setBackgroundColor({ color: "#4CAF50" });
      await StatusBar.setStyle({ style: Style.Light });
      await StatusBar.setBackgroundColor({ color: "#ffffff" });
      await StatusBar.setOverlaysWebView({ overlay: false });


    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setStatusBarStyleLight();
  }, []);



  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route index element={<UserAuthRoutes />} />
          <Route path="explore/*" element={<ExplorePagesRoute />} />
          <Route path="users/*" element={<UserDashboardPagesRoute />} />
          {/* <Route
          path="users/*"
          element={
            <ProtectedRoute>
              <ExplorePagesRoute />
            </ProtectedRoute>
          }
        /> */}
          <Route path="auth/*" element={<UserAuthRoutes />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
